
export class DirectionArtistic{
    constructor(data){
        this.id = data.id;
        this.category = data.category;
        this.subcategory = data.subcategory;
        this.url = data.url;
        this.title = data.title;
        this.title_eng = data.title_eng;
        this.description = data.description;
        this.description_eng = data.description_eng;
        this.artists = data.artists;
        this.link = data.link;
        this.year = data.year;
        this.producer = data.producer;
        this.producer_eng = data.producer_eng;
    } 
}
